import { render, staticRenderFns } from "./MudarCurso.vue?vue&type=template&id=11bc26e0&scoped=true&"
import script from "./MudarCurso.vue?vue&type=script&lang=js&"
export * from "./MudarCurso.vue?vue&type=script&lang=js&"
import style0 from "./MudarCurso.vue?vue&type=style&index=0&id=11bc26e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc26e0",
  null
  
)

export default component.exports